
import { IconButton } from "@mui/material";
import { FileDownload, Image, ContentCopy } from "@mui/icons-material";
import * as XLSX from "xlsx";
import * as htmlToImage from "html-to-image";
import dayjs from "dayjs";

const primaryColor = "#005EB8";

function ExportIcon({ exportRows, exportColumns, exportTableRef, reportName, appendDateTime }) {


  const handleExportExcel = () => {
    console.log("rows1", exportRows);
    // Appending date time here and not passing to ExportIcon with reportName because
    // if the component doesn't re-render before we click Export, the value of reportName remains the same as when it was last rendered.
    if (appendDateTime) {
      const dateTimeNow = dayjs().format("DD_MM_YYYY_HH_mm_ss");
      reportName = `${reportName}_${dateTimeNow}`;
    }
    const worksheet = XLSX.utils.json_to_sheet(exportRows);
    const workbook = XLSX.utils.book_new();
    // Excel sheet names cannot exceed 31 characters
    const rawSheetName = reportName + " Data";
    const sheetName = rawSheetName.length > 31 ? rawSheetName.substring(0, 31) : rawSheetName;
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, reportName + ".xlsx");
  };

  const handleExportImage = async () => {
    if (exportTableRef.current) {
      try {
        const dataUrl = await htmlToImage.toPng(exportTableRef.current);
        const link = document.createElement("a");
        link.download = reportName + "_table.png";
        link.href = dataUrl;
        link.click();
      } catch (error) {
        console.error("Error exporting image:", error);
      }
    }
  };

  const handleCopyData = async () => {
    try {
      const data = exportRows.map((row) => {
        const rowData = {};
        exportColumns.forEach((col) => {
          rowData[col.headerName] = row[col.field];
        });
        return rowData;
      });
      await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
      alert("Data copied to clipboard!");
    } catch (err) {
      console.error("Error copying data:", err);
    }
  };



  return (
    <>
      <IconButton
        onClick={handleExportExcel}
        title="Export Excel 4"
        sx={{ color: primaryColor }}
      >
        <FileDownload />
      </IconButton>
      <IconButton
        onClick={handleExportImage}
        title="Export Image"
        sx={{ color: primaryColor }}
      >
        <Image />
      </IconButton>
      <IconButton
        onClick={handleCopyData}
        title="Copy Data"
        sx={{ color: primaryColor }}
      >
        <ContentCopy />
      </IconButton>
    </>

  );
}


export default ExportIcon;